import React from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation(); // Get current URL path
  const navRef = React.useRef(null);
  const navRef2 = React.useRef(null);
  const onAddClick = (e) => {
    navRef.current.classList.add("active");
    navRef2.current.classList.add("active");
  };
  const onRemoveClick = (e) => {
    navRef.current.classList.remove("active");
    navRef2.current.classList.remove("active");
  };
  const isActive = (path) => location.pathname === path ? "current" : "";
  return (
    <div>
      <header className="main-header style-four style-five" style={{ background: 'white' }}>
        <div className="header-lower">
          <div className="outer-box" style={{ marginLeft: '75px' }}>
            <div className="logo-box">
              <Link to="/">  <img src="assets/images/logo-6.png" alt="" title className='logo' /></Link>
            </div>
            <div className="menu-area clearfix" style={{ paddingRight: "75px" }}>
              <button onClick={onAddClick}>
                <i class="fa fa-bars"></i>
              </button>

              <nav className="main-menu navbar-expand-md navbar-light">
                <div className="collapse navbar-collapse show clearfix">
                  <ul className="navigation clearfix">
                    <li className={isActive("/")}><Link to="/">Home</Link>
                    </li>
                    {/* <li className="dropdown">
                      <Link to="#">Client Services</Link>
                      <ul>
                        <li>
                          <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                        </li>
                        <li>
                          <Link to="/third-party-payroll"> Third Party Payroll </Link>
                        </li>
                        <li>
                          <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                        </li>
                        <li>
                          <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                        </li>
                        <li>
                          <Link to="/candidate-services">Candidate Services</Link>
                        </li>
                      </ul>
                    </li> */}
                    <li className="dropdown">
                      <Link to="#">Client Services</Link>
                      <ul>
                        <li className="dropdown">
                          <Link to="#">India</Link>
                          <ul>
                            <li>
                              <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                            </li>
                            <li>
                              <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                            </li>
                            <li>
                              <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                            </li>

                            <li>
                              <Link to="/third-party-payroll"> Third Party Payroll </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="dropdown">
                          <Link to="#">International </Link>
                          <ul>
                            <li>
                              <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                            </li>
                            <li>
                              <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                            </li>
                            <li>
                              <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                            </li>


                            {/* <li>
                              <Link to="/candidate-services">Candidate Services</Link>
                            </li> */}
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Candidate Services</Link>
                      <ul>
                        <li className="dropdown">
                          <Link to="#">India</Link>
                          <ul>
                            <li><Link to="#">ESI</Link></li>
                            <li><Link to="#">PF Transfer</Link></li>
                            <li><Link to="#">PF Nominees</Link></li>
                            <li><Link to="#">ESS</Link></li>
                          </ul>
                        </li>
                        <li className="dropdown">
                          <Link to="#">International</Link>
                          <ul>
                            <li><Link to="#">Visa Consultant</Link></li>
                            <li><Link to="#">Free Health Checkup</Link></li>
                            <li><Link to="#">Family Care (International)</Link></li>
                            <li><Link to="#">One Month Paid Accommodation</Link></li>
                            <li><Link to="#">Free Insurance Support (First Year)</Link></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className={isActive("/about")}><Link to="/about">About Us</Link>
                    </li>
                    {/* <li className={isActive("/outsourcing")}><Link to="/outsourcing">Service</Link>
                    </li> */}
                    <li className={isActive("/contact")}><Link to="/contact">Contact</Link>
                    </li>

                  </ul>
                </div>
              </nav>

            </div>

          </div>
        </div>
        {/*sticky Header*/}
        <div className="sticky-header">
          <div className="auto-container">
            <div className="outer-box clearfix">
              <div className="menu-area pull-left">
                <Link to="/"> <img src="assets/images/logo-6.png" alt="" title className='logo' style={{ height: 65 }} /></Link>
              </div>
              <nav className="main-menu clearfix">
                <nav className="main-menu navbar-expand-md navbar-light">
                  <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                    <ul className="navigation clearfix">
                      <li className={isActive("/")}><Link to="/">Home</Link>
                      </li>
                      {/* <li className="dropdown">
                        <Link to="#">Service</Link>
                        <ul>
                          <li>
                            <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                          </li>
                          <li>
                            <Link to="/third-party-payroll"> Third Party Payroll </Link>
                          </li>
                          <li>
                            <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                          </li>
                          <li>
                            <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                          </li>
                          <li>
                            <Link to="/candidate-services">Candidate Services</Link>
                          </li>
                        </ul>
                      </li> */}
                      <li className="dropdown">
                        <Link to="#">Client Services</Link>
                        <ul>
                          <li className="dropdown">
                            <Link to="#">India</Link>
                            <ul>
                              <li>
                                <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                              </li>
                              <li>
                                <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                              </li>
                              <li>
                                <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                              </li>

                              <li>
                                <Link to="/third-party-payroll"> Third Party Payroll </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown">
                            <Link to="#">International </Link>
                            <ul>
                              <li>
                                <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                              </li>
                              <li>
                                <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                              </li>
                              <li>
                                <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                              </li>


                              {/* <li>
                              <Link to="/candidate-services">Candidate Services</Link>
                            </li> */}
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link to="#">Candidate Services</Link>
                        <ul>
                          <li className="dropdown">
                            <Link to="#">India</Link>
                            <ul>
                              <li><Link to="#">ESI</Link></li>
                              <li><Link to="#">PF Transfer</Link></li>
                              <li><Link to="#">PF Nominees</Link></li>
                              <li><Link to="#">ESS</Link></li>
                            </ul>
                          </li>
                          <li className="dropdown">
                            <Link to="#">International</Link>
                            <ul>
                              <li><Link to="#">Visa Consultant</Link></li>
                              <li><Link to="#">Free Health Checkup</Link></li>
                              <li><Link to="#">Family Care (International)</Link></li>
                              <li><Link to="#">One Month Paid Accommodation</Link></li>
                              <li><Link to="#">Free Insurance Support (First Year)</Link></li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className={isActive("/about")}><Link to="/about">About Us</Link>
                      </li>
                      {/* <li className={isActive("/outsourcing")}><Link to="/outsourcing">Service</Link>
                      </li> */}
                      <li className={isActive("/contact")}><Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </nav>
            </div>
          </div>
        </div>
      </header>
      <div className="mobile-menu" ref={navRef}>
        <div className="menu-backdrop" />
        <div className="close-btn" ref={navRef2} onClick={onRemoveClick}><i className="fas fa-times" /></div>
        <nav className="menu-box">
          <div className="nav-logo"> <Link to="/"><img src="assets/images/logo-4.png" alt="" title className='logo' /></Link></div>
          <div className="menu-outer">
            <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
              <ul className="navigation clearfix">
                <li className={isActive("/")}><Link to="/">Home</Link> </li>
                <li className="dropdown">
                  <Link to="#">Service</Link>
                  <ul>
                    <li>
                      <Link to="/outsourcing">Manpower Outsourcing Services</Link>
                    </li>
                    <li>
                      <Link to="/third-party-payroll"> Third Party Payroll </Link>
                    </li>
                    <li>
                      <Link to="/performance-based">Performance-Based Temporary Staffing Services</Link>
                    </li>
                    <li>
                      <Link to="/contractual-workforce-solutions">Contractual Workforce Solutions</Link>
                    </li>
                    <li>
                      <Link to="/candidate-services">Candidate Services</Link>
                    </li>
                  </ul>
                </li>
                <li className={isActive("/about")}><Link to="/about">About Us</Link></li>
                {/* <li className={isActive("/outsourcing")}><Link to="/outsourcing">Service</Link> </li> */}
                <li className={isActive("/contact")}><Link to="/contact">Contact</Link> </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}
export default Header;
